import { ApiBaseMidBack } from './base';
import { ApiVersionViewModel } from './types/apiVersionViewModel';

/**
 * @internal
 */
export class ApiMidback extends ApiBaseMidBack {
  getBackVersion() {
    return this.get<ApiVersionViewModel>('/api-version');
  }
}
